import { render, staticRenderFns } from "./addSejourTaxComponent.vue?vue&type=template&id=c17d98b2&scoped=true"
import script from "./addSejourTaxComponent.vue?vue&type=script&lang=js"
export * from "./addSejourTaxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17d98b2",
  null
  
)

export default component.exports